import { ArrowUpRight } from "lucide-react";
import { Reveal } from "@/components/Reveal";
import { CASE_STUDIES } from "@/data/site";
import { scrollToId } from "@/lib/scroll";

const CaseStudies = () => {
  return (
    <section id="case-studies" data-testid="case-studies-section" className="bg-white py-24 sm:py-32">
      <div className="mx-auto max-w-7xl px-5 sm:px-8">
        <div className="flex flex-col lg:flex-row lg:items-end lg:justify-between gap-6">
          <div className="max-w-2xl">
            <Reveal>
              <span className="eb-overline text-brand-blue">Success Stories</span>
            </Reveal>
            <Reveal delay={0.05}>
              <h2 className="mt-5 text-3xl sm:text-4xl lg:text-[2.7rem] leading-[1.08] tracking-tight font-black text-navy-900">
                Measurable results across the world's fleets.
              </h2>
            </Reveal>
          </div>
          <Reveal delay={0.1}>
            <p className="max-w-sm text-sm leading-relaxed text-navy-700/60 font-medium">
              Representative engagements. Client identities are kept confidential
              in line with our advisory standards.
            </p>
          </Reveal>
        </div>

        <div className="mt-12 grid md:grid-cols-3 gap-6">
          {CASE_STUDIES.map((c, i) => (
            <Reveal key={c.title} delay={i * 0.08}>
              <article
                data-testid={`case-study-${i}`}
                className="group h-full flex flex-col border border-silver-200 transition-all duration-300 hover:-translate-y-1 hover:shadow-[0_22px_50px_rgba(10,17,40,0.1)]"
              >
                <div className="relative h-52 overflow-hidden">
                  <img
                    src={c.image}
                    alt={c.title}
                    className="h-full w-full object-cover transition-transform duration-700 group-hover:scale-105"
                    loading="lazy"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-navy-900/70 to-transparent" />
                  <span className="absolute top-4 left-4 bg-white/90 backdrop-blur px-3 py-1 text-[11px] font-bold uppercase tracking-[0.12em] text-navy-900">
                    {c.sector}
                  </span>
                </div>
                <div className="flex flex-col flex-1 p-7">
                  <div className="flex items-baseline gap-2">
                    <span className="text-4xl font-black text-brand-blue tracking-tight">{c.metric}</span>
                    <span className="text-xs uppercase tracking-[0.12em] font-semibold text-navy-700/60">
                      {c.metricLabel}
                    </span>
                  </div>
                  <h3 className="mt-4 text-lg font-bold text-navy-900 tracking-tight">{c.title}</h3>
                  <p className="mt-3 text-sm leading-relaxed text-navy-700/70 flex-1">{c.text}</p>
                </div>
              </article>
            </Reveal>
          ))}
        </div>

        <Reveal delay={0.1}>
          <div className="mt-14 flex flex-col sm:flex-row items-center justify-between gap-6 border border-navy-900 bg-navy-900 p-8 sm:p-10">
            <p className="text-xl sm:text-2xl font-bold text-white tracking-tight text-center sm:text-left">
              Ready to put the same rigour to work for your fleet?
            </p>
            <button
              data-testid="case-studies-cta"
              onClick={() => scrollToId("#contact")}
              className="shrink-0 inline-flex items-center gap-2 rounded-sm bg-brand-blue px-7 py-4 text-sm font-bold text-white transition-all duration-300 hover:bg-white hover:text-navy-900"
            >
              Request a Consultation <ArrowUpRight size={17} />
            </button>
          </div>
        </Reveal>
      </div>
    </section>
  );
};

export default CaseStudies;
